import { CloudOff, CloudUpload, CloudCheck, CloudAlert } from "lucide-react";
import { useOfflineState } from "@/lib/offline/state";

const ICONS = {
  pending: [CloudOff, "text-amber-500", "En attente de synchronisation"],
  sending: [CloudUpload, "text-sky-500 animate-pulse", "Envoi en cours"],
  synced: [CloudCheck, "text-emerald-500", "Synchronisé"],
  conflict: [CloudAlert, "text-red-500", "Conflit de synchronisation"],
};

export const SyncIcon = ({ id, size = "h-4 w-4", testId }) => {
  const { entities, sending, justSynced } = useOfflineState();
  const status = sending === id ? "sending" : entities[id] === "conflict" ? "conflict" : entities[id] ? "pending" : "synced";
  if (status === "synced" && !justSynced[id]) return null;
  const [Icon, cls, label] = ICONS[status];
  return <Icon data-testid={testId || `sync-icon-${id}`} data-status={status} role="img" aria-label={label} className={`${size} shrink-0 ${cls} ${status === "synced" ? "animate-in fade-in" : ""}`} />;
};
